@import "@/styles/variables";

.container {
	display: flex;
	flex-direction: column;
	max-height: fit-content;
	margin-bottom: 1rem;
}

.show_table {
	flex-shrink: 1;
	text-align: right;

	span {
		color: $primary-hover;
		font-weight: bold;
		font-size: 13px;
		width: max-content;
		padding: 4px 10px;
		border: 1px solid $primary-light;
		background: $primary-light;
		border-radius: 10px;
	}
}

.filters {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
	flex-wrap: wrap;
	gap: 10px;
	padding: 0 1rem 0 1rem;
}

.filter_button {
	margin-top: 1.5rem;
	display: flex;
	align-items: flex-end;
	justify-content: center;
}

.apply_filter_btn {
	background: $primary-color;
	color: white;
	border: none;
	padding: 10px 20px;
	border-radius: 8px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	min-height: 40px;

	&:hover:not(:disabled) {
		background: $primary-hover;
		transform: translateY(-1px);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	}

	&:disabled {
		background: $primary-light;
		cursor: not-allowed;
		transform: none;
		box-shadow: none;
	}

	&:active:not(:disabled) {
		transform: translateY(0);
	}
}
